import { render, staticRenderFns } from "./OrderAdd.vue?vue&type=template&id=4787b214&scoped=true"
import script from "./OrderAdd.vue?vue&type=script&lang=js"
export * from "./OrderAdd.vue?vue&type=script&lang=js"
import style0 from "./OrderAdd.vue?vue&type=style&index=0&id=4787b214&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4787b214",
  null
  
)

export default component.exports